import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import 'moment/locale/es'
import 'moment/locale/ru'
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import reactT from "./../../components/reactT";

const langcode = document.querySelector('html').getAttribute('lang');
moment.locale(langcode);
moment.updateLocale(langcode, {
  longDateFormat: {
      L: "MMM DD, YY",
  }
});

class FederatedRangeFacet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: "",
      truncateFacetListsAt: props.truncateFacetListsAt,
      startDate: null,
      endDate: null,
      focusedInput: null,
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.renderDatePresets = this.renderDatePresets.bind(this);
  }

  resetInputs() {
    if (this.props.value.length === 0 && this.state.startDate !== null && this.state.endDate !== null) {
      this.state.startDate = null;
      this.state.endDate = null;
    }
  }

  handleCalendarClose(value) {
    // If there are not start/end dates, we've likely just cleared them, so update props.
    if (value.startDate !== null && value.endDate !== null) {
      // The default time is noon, so start date should start at midnight.
      const momentToSolrStart =
        moment(value.startDate)
          .subtract({ hours: 12 })
          .format("YYYY-MM-DDTHH:mm:ss") + "Z";
      // The default time is noon, so end date should end at 11:59:59.
      const momentToSolrEnd =
        moment(value.endDate)
          .add({ hours: 11, minutes: 59, seconds: 59 })
          .format("YYYY-MM-DDTHH:mm:ss") + "Z";
      this.props.onChange(this.props.field, [
        momentToSolrStart,
        momentToSolrEnd,
      ]);
    }
  }

  handleDatesChange(startDate, endDate) {
    this.setState({ startDate, endDate });
    // If there are no start/end dates, something has just cleared them, so update props.
    if (startDate === null && endDate === null) {
      this.props.onChange(this.props.field, []);
    }
  }

  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate, focusedInput: null });
    this.props.onChange(this.props.field, [moment(startDate).format("YYYY-MM-DDTHH:mm:ss") + "Z", moment(endDate).format("YYYY-MM-DDTHH:mm:ss") + "Z"]);
  }

  renderDatePresets() {
    const today = moment();
    const presets = [
      {
        text: reactT("Last 3 months"),
        start: moment().add(-3, "month"),
        end: today,
      },
      {
        text: reactT("Last 1 year"),
        start: moment().add(-1, "years"),
        end: today,
      },
      {
        text: reactT("Last 3 years"),
        start: moment().add(-3, "years"),
        end: today,
      },
    ];

    return (
      <div className="presets-wrapper">
        {presets.map(({ text, start, end }) => {
          return (
            <button
              key={text}
              type="button"
              className="DayPickerNavigation_button__default preset-button"
              onClick={() =>
                this.onDatesChange({ startDate: start, endDate: end })
              }
            >
              {text}
            </button>
          );
        })}
      </div>
    );
  }

  renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    let i;
    let years = [];
    for (i = moment().year(); i >= moment().year() - 100; i--) {
      years.push(
        <option value={i} key={`year-${i}`}>
          {i}
        </option>
      );
    }
    return (
      <div className="date-list-wrapper">
        <select
          className="month-list"
          value={month.month()}
          onChange={(e) => onMonthSelect(month, e.target.value)}>
          {moment.months().map((label, value) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
        <select
          className="year-list"
          value={month.year()}
          onChange={(e) => onYearSelect(month, e.target.value)}>
          {years}
        </select>
      </div>
    );
  };

  render() {
    this.resetInputs();
    const { label, field } = this.props;
    // Set better react date props for responsive behavior.
    // See: https://github.com/airbnb/react-dates/issues/262
    let calendarOrientation = undefined; // prop will not be added unless set.
    let calendarFullScreen = undefined; // prop will not be added unless set.
    let calendarMonths = 1; // view 1 months on large screens

    const dir = document.getElementsByTagName("html")[0].getAttribute("dir");
    const isRtl = (dir === "rtl") ? true : false;

    // When viewing 2 months, the last month should be the current.
    let getLastMonth = () => moment().subtract(1, "months");

    // Set prop values for mobile.
    if (window.matchMedia("(max-width: 767px)").matches) {
      /* the viewport is less than 600 pixels wide */
      calendarMonths = 1;
      calendarOrientation = "horizontal";
      calendarFullScreen = true;
      getLastMonth = undefined; // prop will not be added on mobile.
    }

    return (
      <div className={`block block-unhcr-search block-${field}`}>
        <div className="accordion-filter pb-0" id={`accordion-${field}`}>
          <div className="card-facet">
            <div
              className="card-header-facet d-flex align-items-center justify-content-between"
              id={label.replace(/\s+/g, "-").toLowerCase()}
            >
                <div className="section-accordion-title d-flex justify-content-between align-items-center">
                  {label}
                </div>
              <span
                className="section-accordion-toggle collapsed"
                role="button"
                data-toggle="collapse"
                data-target={`#collapse-${field}`}
                aria-expanded="false"
                aria-controls={`collapse-${field}`}
                aria-label="Toggle collapse"
              >
              </span>
            </div>

            <div
              id={`collapse-${field}`}
              className="collapse pb-2"
            >
              <div
                className="card-body-facet"
                key={`solr-list-facet-${field}-ul`}
              >
                <DateRangePicker
                  renderCalendarInfo={this.renderDatePresets}
                  startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                  startDateId="solr-start-date" // PropTypes.string.isRequired,
                  endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                  endDateId="solr-end-date" // PropTypes.string.isRequired,
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleDatesChange(startDate, endDate)
                  } // PropTypes.func.isRequired,
                  focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  } // PropTypes.func.isRequired,
                  isOutsideRange={(day) => {
                    const today = moment().format("YYYY-MM-DD");
                    return day.diff(today, "days") > 0;
                  }} // allow only past dates & dates after earliest facet value
                  minimumNights={0} // allow just 1 day (same start/end date)
                  small={true} // use the smaller theme
                  showClearDates // show the clear dates button
                  onClose={(value) => this.handleCalendarClose(value)}
                  // custom phrases for screenreader
                  showDefaultInputIcon={true}
                  phrases={{
                    calendarLabel: "Calendar",
                    chooseAvailableStartDate: ({ date }) =>
                      `Choose ${date} as your search filter start date.`,
                    chooseAvailableEndDate: ({ date }) =>
                      `Choose ${date} as your search filter end date.`,
                    clearDates: "Clear Dates",
                    closeDatePicker: "Close",
                    dateIsSelected: ({ date }) => `You have selected ${date}.`,
                    dateIsUnavailable: ({ date }) =>
                      `Sorry, ${date} is unavailable.`,
                    enterKey: "Enter key",
                    escape: "Escape key",
                    focusStartDate:
                      "Interact with the calendar and add the check-in date for your trip.",
                    hideKeyboardShortcutsPanel: "Close the shortcuts panel.",
                    homeEnd: "Home and end keys",
                    jumpToNextMonth:
                      "Move forward to switch to the next month.",
                    jumpToPrevMonth:
                      "Move backward to switch to the previous month.",
                    keyboardNavigationInstructions:
                      "Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.",
                    keyboardShortcuts: "Keyboard Shortcuts",
                    leftArrowRightArrow: "Right and left arrow keys",
                    moveFocusByOneDay:
                      "Move backward (left) and forward (right) by one day.",
                    moveFocusByOneMonth: "Switch months.",
                    moveFocusByOneWeek:
                      "Move backward (up) and forward (down) by one week.",
                    moveFocustoStartAndEndOfWeek:
                      "Go to the first or last day of a week.",
                    openThisPanel: "Open this panel.",
                    pageUpPageDown: "page up and page down keys",
                    questionMark: "Question mark",
                    returnFocusToInput: "Return to the date input field.",
                    selectFocusedDate: "Select the date in focus.",
                    showKeyboardShortcutsPanel:
                      "Open the keyboard shortcuts panel.",
                    upArrowDownArrow: "up and down arrow keys",
                  }}
                  // > mobile only props
                  initialVisibleMonth={getLastMonth} // large viewports only
                  // mobile only props
                  numberOfMonths={calendarMonths} // view one month at a time
                  orientation={calendarOrientation} // use vertical orientation
                  withFullScreenPortal={calendarFullScreen} // use full screen
                  isRTL={isRtl}
                  startDatePlaceholderText= {reactT('From Date')}
                  endDatePlaceholderText= {reactT('To Date')}
                  renderMonthElement={this.renderMonthElement}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FederatedRangeFacet.defaultProps = {
  value: [],
};

FederatedRangeFacet.propTypes = {
  bootstrapCss: PropTypes.bool,
  children: PropTypes.array,
  collapse: PropTypes.bool,
  facetSort: PropTypes.string,
  facets: PropTypes.array.isRequired,
  field: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onFacetSortChange: PropTypes.func,
  onSetCollapse: PropTypes.func,
  query: PropTypes.object,
  truncateFacetListsAt: PropTypes.number,
  value: PropTypes.array,
};

export default FederatedRangeFacet;
